import BasicMenu from '../../Workbench/components/BasicMenu';

const LinkItem = ({ title, icon, link, deleteHandler, editHandler, canEdit = true }) => {
  const handleLinkClick = (e) => {
    e.stopPropagation();
    window.open(
      link.startsWith('http') ? link : `https://${link}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div className="link-item" onClick={handleLinkClick} style={{ cursor: 'pointer' }}>
      <div className="link-header">
        <div
          style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          <img
            src={icon}
            alt={title}
            style={{
              width: '20px',
              height: '20px',
              objectFit: 'contain',
              flexShrink: 0,
            }}
          />
          <p
            style={{
              marginBottom: 0,
              marginTop: 1,
              padding: 0,
              fontSize: '16px',
              color: 'black',
            }}
          >
            {title}
          </p>
        </div>
        {canEdit && (
          <div onClick={(e) => e.stopPropagation()}>
            <BasicMenu deleteHandler={deleteHandler} editHandler={editHandler} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LinkItem;
